module.exports = __webpack_public_path__ + "img/4-full-md.dae2d031.jpg";